module.exports = {"341102001":"琅琊街道","341102002":"东门街道","341102003":"西门街道","341102004":"南门街道","341102005":"北门街道","341102006":"清流街道","341102007":"扬子街道","341102010":"西涧街道","341102400":"安徽滁州琅琊经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341102.json
// module id = 1021
// module chunks = 0